import { render } from "./myRegistrationDesc.vue?vue&type=template&id=4a1fcaf8&scoped=true"
import script from "./myRegistrationDesc.vue?vue&type=script&lang=js"
export * from "./myRegistrationDesc.vue?vue&type=script&lang=js"

import "./myRegistrationDesc.vue?vue&type=style&index=0&id=4a1fcaf8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1fcaf8"]])

export default __exports__